import { applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { routerMiddleware } from 'react-router-redux'
import logic from '../logic'

const development = require('./development')

const isDevelopment = () => process.env.NODE_ENV !== 'production'

export const createMiddlewareEnhancer = (history) => {
  const middleware = []
  middleware.push(thunk)
  middleware.push(logic)
  middleware.push(routerMiddleware(history))
  if (isDevelopment()) {
    middleware.push(...development.devMiddlewares())
  }
  return applyMiddleware(...middleware)
}
/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
/* eslint-enable */

export const createEnhancer = (history) => {
  const enhancers = []
  enhancers.push(createMiddlewareEnhancer(history))
  if (isDevelopment()) {
    enhancers.push(...development.devEnhancers())
  }
  return composeEnhancers(...enhancers)
}
